export const userConstants = {
	Login: {
		REQUEST : 'USERS_LOGIN_REQUEST',
		SUCCESS : 'USERS_LOGIN_SUCCESS',
		FAILURE : 'USERS_LOGIN_FAILURE'
	},
	Logout: {
		REQUEST : 'USERS_LOGOUT_REQUEST',
		SUCCESS : 'USERS_LOGOUT_SUCCESS',
		FAILURE : 'USERS_LOGOUT_FAILURE'
	},
	RefreshUserData: {
		REQUEST : 'REFRESH_USER_DATA_REQUEST',
		SUCCESS : 'REFRESH_USER_DATA_SUCCESS',
		FAILURE : 'REFRESH_USER_DATA_FAILURE'
	},
	LoginClearError: 'LOGIN_CLEAR_ERROR'
}